import { GameConfigActionTypes, SETCONFIG } from './actionTypes';
import { GameConfigDto } from '../../types/index';

export function setConfig(gameConfig: GameConfigDto): GameConfigActionTypes {
  return { type: SETCONFIG, ...gameConfig };
}